<template>
    <div class="result-content">
        <div class="result-list">
            <div v-for="(item, key) in ticketsResultList"
                 :key="key"
                 class="result-group-wrap">
                <div v-for="(item2, key2) in item"
                     :key="key2"
                     class="result-group">
                    <div class="result-left-block">
                        <div v-for="(item3, key3) in item2.Services"
                             :key="key3"
                             class="result-item align-center">
                            <span class="mr-10 standard-500-text">{{ getDate(item3.BeginDateTime, "DD MMM") }}</span>
                            <div class="airline-info align-center column-2">
                                <img width="24" height="24" class="mr-6"
                                     :src="`${API_ORIGIN}${PATH}/GetImage/GetImage?type=Airline&id=${item3.Airline.Id}&width=50&height=50`"/>
                                <span class="standard-text">{{ item3.Airline.Value }}</span>
                            </div>
                            <div @mouseleave="hidePopover()"
                                 @mouseenter="showPopover(getQuotaText(item3.FlightDetails[item3.selectedTariffIndex]), $event)"
                                 class="mr-8">
                                <icon v-if="getBuyIconStatus(item3.FlightDetails[item3.selectedTariffIndex]) === 'aviailable'"
                                      width="16px" height="16px" name="less" />
                                <icon v-else-if="getBuyIconStatus(item3.FlightDetails[item3.selectedTariffIndex]) === 'less'"
                                      width="16px" height="16px" name="less" />
                                <icon v-else-if="getBuyIconStatus(item3.FlightDetails[item3.selectedTariffIndex]) === 'not-aviailable'"
                                      width="16px" height="16px" name="not-aviailable" />
                                <icon v-else width="16px" height="16px" name="request" />
                            </div>
                            <div class="more-info column-3 align-center standard-text">
                                {{ `${item3.DepartureAirport.Key} – ${item3.ArrivalAirport.Key}` }} •
                                {{ `${item3.Airline.Key} ${item3.Flight.Value}` }} •
                                {{ `${item3.DepartureTime.slice(0, 5)} – ${item3.ArrivalTime.slice(0, 5)}` }}
                            </div>
                            <div v-if="!item[0].tariffChanged" class="column-2-3 tariff">
                                {{ item3.FlightDetails[item3.selectedTariffIndex].Tariff.Name }}
                            </div>
                            <base-select2 v-else
                                          class="column-2-3 mr-8"
                                          :items="item3.tariffs"
                                          @change="changeTariff(key, key2, key3, $event)"
                                          v-model="item3.selectedTariffValue"/>
                        </div>
                    </div>
                    <div class="price-block">
                        <base-button class="mb-4" @click.native="buyTour(item2, key)">
                            {{ correctPrice(item2.Cost) }} {{ getCurrencyDisplayBySettings(item2.rate) }}
                        </base-button>
                        <base-button @click.native="rightModalAviaFlight(item2,key)" :background="getAviaQuotaStatus(item2)"
                                     padding="12px 12px">
                            <svg width="20px" height="20px" fill="#727272">
                                <use xlink:href="../../assets/images/sprite.svg#flight-outline"></use>
                            </svg>
                        </base-button>
                        <p v-if="item2.hasVariants && key2 === 0"
                           @click="changeTariffMode(key)"
                           class="blue-text-small text-center mt-4 pointer">
                            <span v-if="!item2.tariffChanged">{{ localizeList.variants }}</span>
                            <span v-else>{{ localizeList.minimize }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="empty-result" v-if="!ticketsResultList.length">
                <p>
                    {{ localizeList.notFoundFlights }}
                </p>
            </div>
        </div>

        <!--Модальное окно(появляется справо)-->
        <right-modal :show="showRightModal"
                     @toggle="showRightModal = $event">

            <!--Информация по авиа перелетам-->
            <avia-flight-info v-if="aviaFlightInfo.data"
                              :avia-flight-info="aviaFlightInfo"/>

        </right-modal>

        <!--Кнопка вверх-->
        <page-up :show="showPageUp"/>
    </div>
</template>

<script>
    import pageUp from "../baseComponents/pageUp";
    import aviaFlightInfo from "../tour/serviceInfo/aviaFlightInfo";

    import * as typesGlobal from '@/stores/types'

    import moment from "moment"
    import {bus} from "../../main"

    export default {
        name: "ticket-result-list",
        components: {
            pageUp,
            aviaFlightInfo
        },
        data() {
            return {
                API_ORIGIN: this.$store.getters['getApiOrigin'],
                PATH: this.$store.getters['getPath'],
                ticketsResultList: [],
                showRightModal: false,
                aviaFlightInfo: {
                    data: null,
                    services: []
                },
                showPageUp: false
            }
        },
        created() {
            bus.$on("toggle-up-btn", val => {
                this.showPageUp = val;
            });
            bus.$on("changeCurrency", () => {
                this.$store.dispatch("tickets/A_CHANGE_RESULT_CURRENCY")
            })
        },
        mounted() {
            this.setResult()
        },
        computed: {
            getResultList() {
                return this.$store.getters['tickets/getCashSearchResult']
            },
        },
        methods: {
            getCurrencyDisplayBySettings(rate){
                if (!rate) return '';

                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            correctPrice(val) {
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            setResult() {
                // if (!this.getResultList.length)
                //     return;

                let tickets = JSON.stringify(this.getResultList);
                tickets = JSON.parse(tickets);

                let list = tickets.map(x => {
                    let hasVariants = false;
                    x.tariffChanged = false;
                    x.Services = x.Services.map(x2 => {
                        if (x2.FlightDetails.length > 1 || x.Routes > 1)
                            hasVariants = true;

                        x2.tariffs = x2.FlightDetails.map((x3, i3) => {
                            let selectedCost = null;
                            if (i3 === 0 && !x2.selectedTariffIndex) {
                                x2.selectedTariffIndex = 0;
                                x2.selectedTariffValue = x3.Tariff.Key;
                            }
                            if (i3 === 0)
                                selectedCost = x3.Cost;

                            let secondLabel = x3.Cost - selectedCost > 0 ?
                                `+${this.correctPrice(x3.Cost - selectedCost)} ${x.rate.Code}` :
                                `${this.correctPrice(x3.Cost - selectedCost)} ${x.rate.Code}`;

                            return {
                                label: x3.Tariff.Name,
                                value: x3.Tariff.Key,
                                cost: x3.Cost,
                                tourRate: x.rate.Code,
                                secondLabel,
                                allData: x3
                            }
                        });
                        return x2
                    });
                    x.hasVariants = hasVariants;

                    return [x]
                });
                this.ticketsResultList = [...list]
            },
            correctDate(date) {
                return date.split('T')[0].replaceAll('-', '');
            },
            changeTariffMode(key) {
                const href = this.$route.fullPath.split('&');
                const adult = href.find(x => x.includes('adultCount')).split('=')[1];

                const isoCode = href.find(x => x.includes('currency')).split('=')[1];
                let allRate = this.$store.getters['getCurrency'];
                let rate = allRate.find(x => x.IsoCode === isoCode);

                const sendParams = {
                    tourKey: null,
                    cityDeparture: null,
                    startDate: null,
                    cityArrival: null,
                    backDate: null,
                    currency: rate.Code,
                    adult
                };
                let changed = false;
                let rate2 = null;
                this.ticketsResultList = this.ticketsResultList.map((x, i) => {
                    if (i === key) {
                        rate2 = {...x[0].rate};
                        x[0].tariffChanged = !x[0].tariffChanged;
                        changed = x[0].tariffChanged;
                        if (!changed) {
                            x = x.filter((x2, i2) => i2 === 0)
                        }


                        sendParams.tourKey = x[0].Key;
                        sendParams.cityDeparture = href.find(x => x.includes('departureCity')).split('=')[1];
                        sendParams.startDate = this.correctDate(x[0].StartDate);
                        sendParams.cityArrival = href.find(x => x.includes('destinationCity')).split('=')[1];
                        sendParams.backDate = this.correctDate(x[0].Services[x[0].Services.length-1].BeginDateTime);
                    }

                    return x
                });

                if (!changed) return;


                this.$store.dispatch('tickets/A_GET_VARIANTS', sendParams)
                    .then(res => {
                        this.ticketsResultList = this.ticketsResultList.map((x, i) => {
                            if (i === key) {
                                x = res.Result.map(x2 => {
                                    x2.rate = {...rate2};
                                    x2.tariffChanged = true;
                                    x2.Services = x2.Services.map(x3 => {
                                        x3.tariffs = x3.FlightDetails.map((x4, i4) => {
                                            let selectedCost = null;
                                            if (i4 === 0 && !x3.selectedTariffIndex) {
                                                x3.selectedTariffIndex = 0;
                                                x3.selectedTariffValue = x4.Tariff.Key;
                                            }
                                            if (i4 === 0)
                                                selectedCost = x4.Cost;

                                            let secondLabel = x4.Cost - selectedCost > 0 ?
                                                `+${this.correctPrice(x4.Cost - selectedCost)} ${rate.Code}` :
                                                `${this.correctPrice(x4.Cost - selectedCost)} ${rate.Code}`;

                                            return {
                                                label: x4.Tariff.Name,
                                                value: x4.Tariff.Key,
                                                cost: x4.Cost,
                                                tourRate: rate.Code,
                                                secondLabel,
                                                allData: x4
                                            }
                                        });
                                        return x3
                                    });
                                    x2.hasVariants = true;
                                    return x2
                                });
                            }
                            return x
                        });
                    })
            },
            changeTariff(key1, key2, key3, e) {
                let ticket = this.ticketsResultList.find((x, i) => i === key1)[key2];
                let tourists = [];
                let touristNumber = 0;
                let adultCount = location.href.split("adultCount=")[1].split("&")[0];
                for (let i = 0; i < adultCount; i++) {
                    let isMain = i === 0;
                    touristNumber++;
                    tourists.push(
                        this.$store.getters['tickets/IndividualSimpleTourist'](isMain, touristNumber)
                    )
                }

                let services = [];
                ticket.Services.forEach((x, i) => {
                    let selectedTariff = e.allData;
                    if (i !== key3) {
                        selectedTariff = x.FlightDetails[x.selectedTariffIndex]
                    }

                    const service = this.$store.getters['basket/getReservationService']({
                        serviceType: x.SvKey,
                        code: x.Flight.Key,
                        subcode1: selectedTariff.Tariff.Key,
                        subcode2: x.DepartureCity.Key,
                        packet: x.PacketId,
                        partner: selectedTariff.PartnerId,
                        day: x.Day,
                        durationInNight: x.DurationInNight,
                        cityId: x.ArrivalCity.Key,
                        countryId: x.ArrivalCountry.Key,
                        templateId: x.Id,
                        cost: selectedTariff.Cost,
                        isInvisible: x.IsHooded,
                        isNotCalculated: x.IsNotCalculate,
                        quotaStatus: selectedTariff.QuotaStatus,
                        beginDateTime: x.BeginDateTime,
                        index: x.Index,
                        isRoute: true,
                        byPax: selectedTariff.ByPax,
                        endDateTime: x.EndDateTime,
                        remoteId: null,
                        isRemovable: x.IsDeleted,
                        appliedCostOffersIds: null
                    });
                    delete service.AppliedCostOffersIds;
                    delete service.RemoteId;
                    services.push(service)
                });

                services = services.map(x => {
                    return {
                        Service: x,
                        TouristNumbersList: tourists.map(x2 => x2.Number)
                    }
                });

                const sendParams = {
                    beginDate: ticket.StartDate,
                    currency: ticket.rate.Code,
                    duration: ticket.Duration,
                    initialPrice: {
                        currency: ticket.rate.Code,
                        price: ticket.Cost
                    },
                    services: services,
                    tourProgramId: ticket.Key,
                    tourists: tourists
                };
                this.$store.dispatch("tickets/A_CHANGE_TARIFF", sendParams)
                    .then(res => {
                        let newCost = res.CalculatedReservation.TotalPrice;
                        this.ticketsResultList = this.ticketsResultList.map((x, i) => {
                            if (i === key1) {
                                x[key2].Cost = newCost;
                                x[key2].Services = x[key2].Services.map((x2, i2) => {
                                    if (i2 === key3) {
                                        let index = x2.tariffs.map(x3 => x3.value).indexOf(e.value);
                                        x2.selectedTariffIndex = index;
                                        x2.selectedTariffValue = e.value;
                                        x2.tariffs = x2.tariffs.map(x3 => {
                                            let selectedCost = e.cost;

                                            let secondLabel = x3.cost - selectedCost > 0 ?
                                                `+${this.correctPrice(x3.cost - selectedCost)} ${x[key2].rate.Code}` :
                                                `${this.correctPrice(x3.cost - selectedCost)} ${x[key2].rate.Code}`;

                                            x3.secondLabel = secondLabel;

                                            return x3
                                        })
                                    }

                                    return x2
                                })
                            }

                            return x
                        });
                    })
            },
            getRateByCode(code) {
                return this.$store.getters['getCurrency'].find(x => x.Code === code)
            },
            buyTour(item) {
                const href = window.location.href.split("&");

                const currency = this.getRateByCode(item.Rate).IsoCode;
                const tourKey = item.Key;
                const dCity = item.CityDepature.Key;
                const aCountry = item.CountryId;
                let date = item.StartDate.split("T")[0].split("-").reverse();
                date[2] = date[2].slice(2);
                date = date.join(".");
                const duration = +item.DurationInNight + 1;

                let adultCount = href.find(x => x.includes("adultCount"));
                adultCount = adultCount ? adultCount.split("=")[1] : adultCount;

                let childAges = href.find(x => x.includes("childAges"));
                childAges = childAges ? childAges.split("=")[1] : childAges;

                const aviaQuota = href.find(x => x.includes("aviaQuota"));

                let serviceDescriptions = item.MinCostServicesComposition.map((x, i) => {
                    let res = [];
                    Object.values(x.Key).forEach(x2 => res.push(x2));
                    res.push(x.Value.ServiceType);
                    res.push(x.Value.Code);
                    res.push(item.Services[i].selectedTariffValue);
                    res.push(x.Value.SubCode2);
                    res.push(x.Value.CountryId);
                    res.push(x.Value.CityId);
                    res.push(x.Value.PacketId);
                    res.push(x.Value.PartnerId);
                    res.push(x.Value.Day);
                    res.push(x.Value.DurationInNight);
                    return res.join("_")
                });

                let newUrl = `Basket?departureCities=${dCity}` +
                    `&destination=1_${aCountry}` +
                    `&tour=${tourKey}` +
                    `&date=${date}` +
                    `&duration=${duration}` +
                    `&hotelScheme=[{%20"TemplateId"%3A"}]` +
                    `&adultCount=${adultCount}` +
                    (childAges ? `&childAges=${childAges}` : "") +
                    `&${aviaQuota}` +
                    `&serviceDescriptions=${serviceDescriptions.join(",")}` +
                    `&currency=${currency}`

                let beforeHash = window.location.href.split("#")[0];
                beforeHash = beforeHash + "#/" + newUrl;
                this.cashSearchHref();
                window.open(beforeHash)
            },
            cashSearchHref() {
                // return
                const href = window.location.href;
                sessionStorage.setItem('searchHref', href);
            },
            rightModalAviaFlight(item) {
                this.aviaFlightInfo.services = [];
                this.showRightModal = true;
                this.aviaFlightInfo.data = item;
                item.Services.forEach((x) => {
                    if (x.SvKey === 1) {
                        if (!this.aviaFlightInfo.services.length) {
                            this.aviaFlightInfo.services.push([x])
                        } else {
                            if (x.FlightSetting.ServiceId === this.aviaFlightInfo.services[0][0].FlightSetting.ServiceId) {
                                this.aviaFlightInfo.services[0].push(x)
                            } else {
                                if (!this.aviaFlightInfo.services[1]) {
                                    this.aviaFlightInfo.services.push([x])
                                } else {
                                    this.aviaFlightInfo.services[1].push(x)
                                }
                            }
                        }
                    }
                });
            },
            getAviaQuotaStatus(item) {
                let aviaQuota = 3;
                item.Services.forEach(x => {
                    if (x.FlightDetails && x.FlightDetails[0].QuotaStatus.PlacesStatus === 4) {
                        aviaQuota = 0
                    } else if (x.FlightDetails && x.FlightDetails[0].QuotaStatus.PlacesStatus === 1 && x.FlightDetails[0].QuotaStatus.FreePlaces > 0) {
                        if (aviaQuota > 0) {
                            aviaQuota = 1
                        }
                    } else if (x.FlightDetails && x.FlightDetails[0].QuotaStatus.PlacesStatus === 1 && x.FlightDetails[0].QuotaStatus.FreePlaces === 0) {
                        if (aviaQuota > 1) {
                            aviaQuota = 2
                        }
                    } else if (x.FlightDetails && x.FlightDetails[0].QuotaStatus.PlacesStatus === 2) {
                        if (aviaQuota == 3) {
                            aviaQuota = 3
                        }
                    }
                });
                if (aviaQuota === 2) {
                    return "#4ACA7F"
                } else if (aviaQuota === 1) {
                    return "var(--primary-color)"
                } else if (aviaQuota === 0) {
                    return "var(--yellow-color)"
                } else if (aviaQuota === 3) {
                    return "#ff0000"
                }
            },
            getDate(date, format) {
                return moment(date).format(format)
            },
            getBuyIconStatus(item) {
                const quota = item.quotaStatus || item.QuotaStatus;
                if (quota.PlacesStatus === 1 && quota.FreePlaces === 0) {
                    return "aviailable"
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    return "less"
                } else if (quota.PlacesStatus === 4) {
                    return "request"
                } else if (quota.PlacesStatus === 2) {
                    return "not-aviailable"
                }
            },
            getQuotaText(item) {
                const quota = item.quotaStatus || item.QuotaStatus;
                let res = null;
                if (quota.PlacesStatus === 4) {
                    res = this.localizeList.onRequest
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                    res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                } else if (quota.PlacesStatus === 2) {
                    res = this.localizeList.quotaHasNoPlaces
                } else {
                    res = this.localizeList.available
                }
                return res
            },
            showPopover(text, e) {
                let rect = e.target.getBoundingClientRect();
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height
                }
                this.$store.dispatch(typesGlobal.A_SHOW_POPOVER, res)
            },
        },
        watch: {
            getResultList: {
                deep: true,
                handler() {
                    this.setResult()
                }
            }
        }
    }
</script>

<style scoped>
    .result-content {
        padding: 18px 60px;
    }
    .vertical-filters .result-content {
        padding-left: 16px;
    }

    .result-group-wrap {
        background-color: var(--white-color);
        box-shadow: 0 2px 10px rgba(0, 0, 0, .08);
        border-radius: 6px;
        /*display: flex;*/
    }

    .result-group-wrap:not(:last-child) {
        margin-bottom: 20px;
    }

    .result-group {
        display: flex;
        /*flex-direction: column;*/
        /*justify-content: center;*/
        align-items: center;
        flex: 1;
        padding: 8px 0 8px 20px;
    }

    .result-group:not(:first-child) {
        border-top: 1px dashed #aaa;
    }

    .result-left-block {
        flex: 1;
    }

    .result-item {
        display: flex;
    }

    .result-item .column-2 {
        flex: 2
    }

    .result-item .column-3 {
        flex: 3;
    }

    .result-item .column-2-3 {
        flex: calc(2 + 1 * (100 / 1024));
    }

    .result-item:not(:last-child) {
        border-bottom: 1px solid #aaa;
        padding-bottom: 8px;
    }

    .result-item:not(:first-child) {
        padding-top: 8px;
    }

    .result-item .more-info {
        margin-right: 8px;
        white-space: nowrap;
    }

    .result-item .tariff {
        line-height: 28px;
    }

    .result-item /deep/ .base-select2 .select {
        padding: 6px 40px 6px 6px;
    }

    .price-block {
        padding: 15px 20px 15px 15px;
        border-left: 1px solid #aaa;
        min-width: 130px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .empty-result {
        font-size: 18px;
    }
</style>
